import { createSlice } from '@reduxjs/toolkit';

const strategyCollections = createSlice({
  name: 'STRATEGY_COLLECTIONS',
  initialState: {}, // comes from preloadedState in the store (see buildStrategyCollections)
  reducers: {
    setStrategyCollections(state, action) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setStrategyCollections } = strategyCollections.actions;

export default strategyCollections.reducer;
